export default {
  strict: true,
  namespaced: true,
  state: {
    edit: {
      id: '',
      target: ''
    }
  },
  mutations: {
    setFlightEditData (state, data) {
      for (let field in data) {
        state.edit[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/flights/edit.js